module.exports = __webpack_public_path__ + "img/20190621161744563.0d41d928.png";